defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubPage',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Models/PlayTogetherClub',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Modal',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Ribbon',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/ClubCard'
  ],
  function (m, Params, PlayTogetherApi, Utils, PlayTogetherClubModel, Loader, Modal, CtaButton, Ribbon, ClubCard) {
    const ClubPage = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.navigationPaths = this.settings.navigation;
        this.clubId = m.prop(Params.extract('klubId'));
        if (!this.clubId()) {
          window.history.back();
        }
        // General modals used by `ClubPage`
        this.modal = new Modal();
        this.errorModal = new Modal();

        this.isLoadingClubModel = m.prop(true);
        this.clubModel = m.prop(null);
        this.clubModelFields = m.prop(null);
        this.openEditClubName = m.prop(null);

        this.clubName = m.prop(null);
        this.clubTheme = m.prop(null);
        this.clubBackground = m.prop(null);
        this.clubBadge = m.prop(null);
        this.clubBadgeBackground = m.prop(null);
        this.clubSettings = m.prop(null);
        this.clubActivityFeed = m.prop(null);
        this.showCreatePlayButton = m.prop(false);

        // current user props:
        this.currentUser = m.prop(null);
        this.currentUserId = m.prop(null);
        this.isCurrentUserChairman = m.prop(null);

        // error handling:
        this.error = m.prop(null);
        this.isErrorOverlayOn = m.prop(false);
        const onConfirmErrorOverlay = () => {
          this.error(null);
          this.isErrorOverlayOn(false);
        };
        const openErrorOverlay = () => {
          const errorText = this.error();
          const modalContent = this.errorModal.defaultContentTemplate({
            heading: this.rootDictionary?.get('ErrorMessages/GenericTitle'),
            body: m.trust(errorText),
            footer: CtaButton({
              text: this.rootDictionary?.get('ErrorMessages/OkUnderstoodButton'),
              onClick: this.errorModal.close,
              options: ['primary']
            })
          });
          this.errorModal.setContent(modalContent);
          this.errorModal.onClose(onConfirmErrorOverlay);
          this.errorModal.show();
        };
        this.hasError = () => {
          if (this.error() && !this.isErrorOverlayOn()) {
            openErrorOverlay();
            this.isErrorOverlayOn(true);
          }
        };

        // get club info:
        if (!this.clubModel()) {
          PlayTogetherApi.getClub(this.clubId()).then((response) => {
            if (response.feed) {
              this.clubActivityFeed(response.feed.reverse());
            }
            // setup club model props
            this.clubModel(PlayTogetherClubModel.new(response));
            this.clubModelFields(this.clubModel().fields);

            // setup club
            this.clubName(this.clubModelFields().clubName);
            this.clubTheme(this.clubModelFields().theme);
            this.clubBackground(this.clubTheme().background());
            this.clubBadge(this.clubTheme().badge());
            this.clubBadgeBackground(this.clubTheme().badgeBackground());
            this.clubSettings(this.clubModelFields().rules);

            // setup current user props
            this.currentUser(this.clubModel().currentUser());
            this.currentUserId(this.currentUser().customerId);
            this.isCurrentUserChairman(this.currentUser().isChairman());

            this.showCreatePlayButton(this.isCurrentUserChairman() || this.clubSettings().allowAllCreate());

            this.isLoadingClubModel(false);
            this.property('clubPageController', this);
            m.redraw();
          }, (response) => {
            this.isLoadingClubModel(false);
            this.error(response);
            m.redraw();
          });
        }

        const $pageWrapper = document.querySelector('.page-area');
        if ($pageWrapper) {
          $pageWrapper.classList.add('play-together-club-page__outer');
        }

        // Add event listener for redireting on user logout
        Utils.redirectOnLogout(this.navigationPaths.redirectOnLogoutPage);
        Utils.checkLoginStatus();
      },
      view: function (controller, args, slots) {
        if (controller.isLoadingClubModel()) {
          return Loader(controller);
        }

        if (controller.error() && !controller.clubModel()) {
          return m('.play-together-club-page',
            m('.play-together-club-page__inner',
              m('.play-together-club-page__content',
                ClubCard({
                  $content: m('.play-together-club-page__content-text', controller.error())
                })
              )
            )
          );
        }

        if (controller.error()) {
          controller.hasError();
        }

        const clubTheme = controller.clubModelFields().theme;
        const clubColor = clubTheme.colorTheme();
        const clubBackground = clubTheme.background;
        const clubBadge = clubTheme.badge;
        const clubBadgeBackground = clubTheme.badgeBackground;
        const setThemeVars = () => {
          if (clubColor && Utils.isValidHexCode(clubColor.code)) {
            Utils.setCssHslVariables({
              hexColor: clubColor.code
            });
          }

          if (clubBackground()) {
            document.documentElement.style.setProperty('--club-theme-background-image-url', 'url(' + clubBackground().url + ')');
          }
        };

        const $editClubNameButton = CtaButton({
          icon: 'edit',
          className: 'edit-club-name-btn',
          onClick: controller.openEditClubName()
        });
        const showEditButton = args.mode === 'settings' && controller.openEditClubName();

        return m('.play-together-club-page', {
          class: controller.clubPageClassName?.() || '',
          config: setThemeVars
        }, m('.play-together-club-page-actions', { class: slots?.hideFlowHeaderClass ? slots.hideFlowHeaderClass : null }, [
          slots.flowHeader
        ]),
        m('.play-together-club-page__inner', [
          m('.play-together-club-page__top', [
            m('.play-together-club-page__top-ribbon', [
              m('a.play-together__ribbon--link', {
                href: `${controller.navigationPaths.clubPage}?klubId=${controller.clubId()}`
              }, Ribbon({
                title: controller.clubName(),
                badge: clubBadge(),
                badgeBackground: clubBadgeBackground(),
                $editButton: showEditButton ? m('.mobile-only', $editClubNameButton) : null
              })),
              showEditButton ? m('.mobile-hide', $editClubNameButton) : null
            ]),
            m('.play-together-club-page__top-buttons', { class: slots.hideTopButtons ? 'play-together-club-page__top-buttons--hidden' : '' },  [
              controller.showCreatePlayButton() ? CtaButton({
                text: controller.rootDictionary?.get('ClubPage/CreateGame'),
                icon: 'createGame',
                href: controller.navigationPaths.createPlayChooseGamePage + '?klubId=' + controller.clubModelFields().clubId(),
                options: ['top-menu-item', 'no-border', 'club-color-on-active-page']
              }) : null,
              CtaButton({
                text: controller.rootDictionary?.get('ClubPage/MyCouponsButton'),
                icon: 'kuponer',
                href: `${controller.navigationPaths.clubCouponsPage}?klubId=${controller.clubId()}`,
                options: ['top-menu-item', 'no-border', 'club-color-on-active-page']
              }),
              CtaButton({
                text: controller.rootDictionary?.get('ClubPage/ClubActivities'),
                icon: 'clubActivities',
                href: `${controller.navigationPaths.clubPage}?klubId=${controller.clubId()}`,
                options: ['top-menu-item', 'no-border', 'club-color-on-active-page']
              }),
              CtaButton({
                text: controller.rootDictionary?.get('ClubPage/ClubDetailsButton'),
                icon: 'settings',
                href: `${controller.navigationPaths.settingsPage}?klubId=${controller.clubId()}`,
                options: ['top-menu-item', 'no-border', 'club-color-on-active-page']
              }),
            ])
          ]),
          slots.title ? m('.play-together-club-page__title', slots.title) : null,
          slots.description && typeof slots.description !== 'object' ? m('.play-together-club-page__description', m.trust(slots.description)) : null,
          m('.play-together-club-page__content', [
            slots.customContent?.({ rootController: controller }) || ClubCard({
              $header: slots.header ? slots.header : null,
              $flowHeader: slots.flowHeader,
              $content: slots.content ? m(slots.content, { controller }) : null
            })
          ])
        ]));
      }
    };

    // Public functions:
    return ClubPage;
  });
